export default __webpack_public_path__ + "static/media/mesh100.f7a341a9.png";